import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { TextS } from '../typography/typography';
import { InputEvents } from './types';
import { Logger } from '../../../observability/logger';
import { t } from '../../../i18n';
export var Limit = function (_a) {
    var inputRef = _a.inputRef;
    var _b = useState(0), count = _b[0], setCount = _b[1];
    var _c = useState(undefined), limit = _c[0], setLimit = _c[1];
    useEffect(function () {
        if (!(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
            return;
        }
        setCount(inputRef.current.getCharacterCount());
        setLimit(inputRef.current.getCharacterLimit());
        var handleUpdate = function (e) {
            var event = e;
            if (event.detail.id === inputRef.current.getInputId()) {
                setCount(event.detail.count);
                setLimit(event.detail.limit);
            }
        };
        document.addEventListener(InputEvents.UPDATE_COUNT, handleUpdate);
        // eslint-disable-next-line consistent-return
        return function () {
            document.removeEventListener(InputEvents.UPDATE_COUNT, handleUpdate);
        };
    }, [inputRef]);
    if (!inputRef || !inputRef.current) {
        Logger.error('Input limit component crashed', {
            error: 'Input ref is not provided or not initialized',
            inputRef: JSON.stringify(inputRef),
            action: 'Input limit component crashed',
        });
        return null;
    }
    if (limit === undefined || limit === null)
        return null;
    return (_jsx(TextS, { color: "tertiary", children: t('common:input.characters_left_with_total', { remaining: limit - count, total: limit }) }));
};
